import { useMemo } from "react";
import { useAccess } from "../context/AccessContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { scopeByRoles } from "../utils/workspaceAccess";

export default function useWorkspaceAccess() {
  const access = useAccess();
  const { activeTeam, ready } = useWorkspace();
  const assignedRoles = activeTeam?.roles;
  const roleNames = useMemo(
    () => assignedRoles || [],
    [assignedRoles],
  );

  const permissions = useMemo(
    () => scopeByRoles(access.permissions, roleNames),
    [access.permissions, roleNames],
  );
  const features = useMemo(
    () => (access.isAdmin ? access.features : scopeByRoles(access.features, roleNames)),
    [access.isAdmin, access.features, roleNames],
  );

  return {
    permissions,
    features,
    isAdmin: access.isAdmin,
    loading: access.loading,
    reload: access.reload,
    workspaceReady: ready !== false,
  };
}
